<template>
  <div id="app" v-if="isRouterAlive">
    <!-- <ComHeader
      v-if="!(name === '404' || name === 'login'  || name === 'Home')"
    ></ComHeader> -->
    <ComHeaderOne
      v-if="!(name === '404' || name === 'login'  || name === 'Home')"
    ></ComHeaderOne>
    <!-- <keep-alive> -->
      <!-- 如果当前打开页面的路由中 keepAlive: true （开启了缓存时） -->
      <!-- <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    v-if="!$route.meta.keepAlive" -->
    <router-view
      v-bind:style="{ minHeight: Height + 'px' }"
    />
    <!-- <ComFooter v-if="!(name === '404' || name === 'Home')"></ComFooter> -->
  </div>
</template>
<script>
import ComHeader from "./components/ComHeader.vue";
// import ComHeader from "./components/ComHeader.vue";
import ComFooter from "./components/ComFooter.vue";
import ComHeaderOne from "./components/ComHeaderOne.vue";

export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      Height: 1200,

      isRouterAlive: true,
      name: "",
      
     
    };
  },
  created() {},
  // watch:{
  //   $route(to,from){
  //     this.name = to.name;
  //   }
  // },
  watch: {
    $route(to, from) {
      this.name = to.name;
    },
    // $route: {
    //   handler(to, from) {
    //     this.name = to.name;
    //     this.code = this.$route.query.code;
    //     console.log(this.code);
    //     this.reload()
    //   },
    //   deep: true,
    // },
  },
  mounted() {
    console.log(this.$route.path);
    this.path = this.$route.path;
  },
  mounted() {
    //动态设置内容高度 让footer始终居底   header+footer的高度是190
    this.Height = document.documentElement.clientHeight - 170; //监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 170;
    };
  },
  methods: {
    // login(or) {
    //   // console.log(typeof or)
    //   this.loginShow = true;
    //   console.log(this.loginShow);
    // },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
  components: {
    ComHeader,
    ComFooter,
    ComHeaderOne,
  },
};
</script>
<style lang="less">
#app {
  // width: 90%;
  // margin: auto;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
</style>
